import { useSakeDatasTable } from '../hooks/useSakeDatasTable';
import { CommonDataList } from '../components/CommonDataList';

const SakeDatasPage = () => {
  const { table, loading, error } = useSakeDatasTable('src.services.sake_datas_service');

  return (
    <CommonDataList
      table={table}
      loading={loading}
      error={error}
      title="日本酒リスト"
    />
  );
};

export default SakeDatasPage